import './app/dayjs-setup';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { Subject } from 'rxjs';

// 🚨 [BLINDAGEM GLOBAL DE RXJS CONTRA ObjectUnsubscribedError]
// Intercepta qualquer "next", "subscribe", "complete" ou "error" tentado num Subject que já foi destruído/fechado
// Protege toda a app contra 'ObjectUnsubscribedError: object unsubscribed' (ex: ngu-carousel, modals, teardowns assíncronos)
const originalSubscribe = Subject.prototype.subscribe;
Subject.prototype.subscribe = function (...args: any[]) {
  if (this.closed) {
    return { unsubscribe: () => {}, closed: true };
  }
  return originalSubscribe.apply(this, args);
} as any;

const originalNext = Subject.prototype.next;
Subject.prototype.next = function (...args: any[]) {
  if (this.closed) {
    return;
  }
  return originalNext.apply(this, args);
} as any;

const originalComplete = Subject.prototype.complete;
Subject.prototype.complete = function (...args: any[]) {
  if (this.closed) {
    return;
  }
  return originalComplete.apply(this, args);
} as any;

const originalError = Subject.prototype.error;
Subject.prototype.error = function (...args: any[]) {
  if (this.closed) {
    return;
  }
  return originalError.apply(this, args);
} as any;

if (environment.production) {
  enableProdMode();
  window['isMobile'] = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  // 🔒 Preservar métodos originais do console antes de desabilitá-los
  // Isto permite que o LoggingService os restaure dinamicamente
  window['__originalConsole'] = {
    log: console.log.bind(console),
    debug: console.debug.bind(console),
    info: console.info.bind(console),
    warn: console.warn.bind(console),
    error: console.error.bind(console),
  };

  // 🔇 Desabilitar TODOS os console logs em produção por padrão
  // (incluindo console.error para evitar leak de informação sensível)
  if (!environment.features || !environment.features.showLogs) {
    const noop = () => {};
    console.log = noop;
    console.debug = noop;
    console.warn = noop;
    console.info = noop;
    console.error = noop; // ✅ Agora também desabilita console.error
  } else {
    console.info('🔍 Logs de debug ativos via environment configuration');
  }
}

performance.mark('bootstrap-start');

function bootstrapApp() {
  function bootstrap() {
    try {
      platformBrowserDynamic()
        .bootstrapModule(AppModule)
        .then(ref => {
          performance.mark('bootstrap-end');
          performance.measure('bootstrap', 'bootstrap-start', 'bootstrap-end');
          // console.log('⏱️ Tempo de bootstrap:', performance.getEntriesByName('bootstrap'));

          if (window['ngRef']) {
            window['ngRef'].destroy();
          }
          window['ngRef'] = ref;
        })
        .catch(err => console.error('Erro ao iniciar Angular:', err));
    } catch (e) {
      console.error('🚀 CRASH NO PONTO 2: Erro fatal no bootstrap', e);
    }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    bootstrap();
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      bootstrap();
    });
  }
}

// ✅ Bootstrap IMEDIATO — o Angular arranca sem esperar pelo Service Worker
// O SW regista-se em paralelo (background), não bloqueia o carregamento
bootstrapApp();

// 🗑️ Limpeza e desactivação agressiva de todos os Service Workers e caches
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then(registrations => {
      for (const registration of registrations) {
        registration.unregister().then(success => {
          if (success) {
            console.warn('🗑️ [ServiceWorker] Service worker antigo desregistado activamente para evitar cache.');
          }
        });
      }
    })
    .catch(err => console.error('Erro ao procurar Service Workers:', err));
}

if ('caches' in window) {
  caches
    .keys()
    .then(keys => {
      keys.forEach(key => {
        caches.delete(key).then(success => {
          if (success) {
            console.warn(`🗑️ [CacheStorage] Cache de rede '${key}' eliminada com sucesso.`);
          }
        });
      });
    })
    .catch(err => console.error('Erro ao limpar Cache Storage:', err));
}

// Captura global de erros
window.addEventListener('error', event => {
  console.error('[Erro Global]', event.message, event.error);
});
window.addEventListener('unhandledrejection', event => {
  console.error('[Promise não tratada]', event.reason);
});
